export const NAME = 'cp:dialog-close'

export default function createEvent() {
    return new CustomEvent(NAME, {
        bubbles: true,
        composed: true,
    })
}
